 /*
 * Marionette ItemView: VersionInformationView
 * -------------------------
 * Displays a version information
 */
import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import template from '@/../templates/preview-popover-template.hbs';
import s from 'amdi18n-loader!@/nls/preview';

    var globalCh = Radio.channel('global');

    var SwitchServerView = Marionette.View.extend({
        template: Handlebars.compile(template),
        templateOptions: { data: { intl: s } },
        templateContext: function(){
            var data = {
                url: globalCh.request('app_options', 'production_environment_url') || '#',
                email: globalCh.request('app_options', 'flexible_deploy_feedback_email') || '#'
            };

            return data;
        }
    });
    export default SwitchServerView;

